<svelte:body on:item={put_item}/>
<script>
    import _ from 'lodash';
    import {validate_int} from '../../../validators.js';
    import {parameter, network, store} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import RalColor from "../../parts/RalColor.svelte";
    import DekoRalColor from "../../parts/DekoRalColor.svelte";
    import {decode, encode} from "../../../helpers";

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;
    const user = store('credential', 'getAuth');

    export let calc;
    export let options;

    // Настройки для 34 Сергей Астрахань
    if (APP_TYPE === 'axis-one' && parseInt($user.idSklad) === 34) {
        options = {
            ...options,
            max: {
                width: 2100,
                height: 2500
            },
            recomend: {
                width: 2100,
                height: 2500
            },
        }
    }

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {

            let fetched = await network.fetch_tovar(item.idTovar);
            if (fetched.ind3.length > 30) {
                let json = JSON.parse(decode(fetched.ind3));

                width.set(json.width);
                height.set(json.height);
                ind1 = json.ind1;
                ind2.set(json.ind2);
                ind3 = json.ind3;
                porog = json.porog;
                webtype.set(json.webtype);
                type = json.type;
                vidShtor = json.vidShtor;
                cvetShtor = json.cvetShtor;


            } else {
                let title = item.title.split(' ', 3);

                width.set(title[1].split('x')[0]);
                height.set(title[1].split('x')[1]);
                ind2.set(title[2]);
                ind3 = otkrivanie.find((el) => item.title.toLowerCase().includes(el.toLowerCase()));
                ind1 = uplotnenie.find((el) => item.title.toLowerCase().includes(el.toLowerCase()));
                porog = item.title.toLowerCase().includes('низкий') ? 'Низкий' : 'Рамный';
                webtype.set(webtypes.find((el) => item.title.toLowerCase().includes(el.toLowerCase())));

                type = [...types]
                    .sort((a, b) => b.length - a.length)
                    .find((el) => item.title.toLowerCase().includes(el.toLowerCase())) ?? type;


                count.set(+item.quantity);
                comment.set(item.comment);
                fetchData = await fetch($ind2);
                change();
            }
        }
    };

    const otkrivanie = [
        'Створка влево',
        'Створка сверху вниз',
        'Створка снизу вверх',
        'Створка вправо',
        'Створка от краев к середине',
        'Створка от середины к краям'
    ];

    const uplotnenie = [
        'Без уплотнения',
        'Щеточный',
        'Магнитный'
    ];

    const color = options.color || {
        'Антрацит': 'Антрацит',
        'Белый': 'Белый',
        'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
        'Неокрашенный': 'Неокрашенный',
        'Цветной': 'Цветной',
    };

    const webtypes = options.webtype || [
        'Обычная',
    ];

    const types = ['Сетка', 'Ткань', 'Сетка/Ткань'];
    const SHTORKA_TYPES = [
        {type: 'Полупрозрачная', keyword: ['плиссированная шторка из полиэстера']}, // --
        {type: 'Dark out 90% затемнения', keyword: ['плиссированная шторка однослойный darkout']}, // --
        {type: 'СОТЫ BLACKOUT ПРЕМИУМ', keyword: ['шторка премиум сота']}, // --
        {type: 'СОТА BLACKOUT КЛАССИК', keyword: ['шторка классик сота']}, // --
        {type: 'СОТЫ полупрозрачные КЛАССИК', keyword: ['шторка полупрозрачная сота']},
        {type: 'BLACKOUT однослойный', keyword: ['шторка blackout однослойный']}, // --
        {type: 'СОТЫ BLACKOUT', keyword: ['шторка blackout сота']},
    ];

    function availableShtorTypes(result) {
        if (!result) return [];

        const names = result.filter(i => i.flag === '1').map(i => i.name.toLowerCase());

        return SHTORKA_TYPES.filter(({keyword}) =>
            keyword.some(kw => names.some(n => n.includes(kw)))
        );
    }

    // Список цветов шторки в зависимости от вида
    function shtorkaColors(type, result) {
        if (!result) return [];
        const entry = SHTORKA_TYPES.find(t => t.type === type);
        if (!entry) return [];

        const l = [...new Set(
            result
                .filter(i => entry.keyword.some(kw => i.name.toLowerCase().includes(kw)) && i.flag === '1')
                .map(i => i.ind2.trim())
                .filter(Boolean)
        )]

        //  ind4 = l[0];

        return l;
    }

    function shtorkaKeywordForCalc(type, colorValue, result) {
        const entry = SHTORKA_TYPES.find(t => t.type === type);
        if (!entry) return [];

        // Если у типа один keyword
        if (entry.keyword.length === 1) return entry.keyword;

        // Если несколько
        const matched = entry.keyword.filter(kw =>
            result.some(i =>
                i.name.toLowerCase().includes(kw) &&
                i.ind2.trim() === colorValue
            )
        );

        return matched.length ? matched : entry.keyword;
    }

    const fetch = async (color = 'Белый') => {
        let result = await network.fetch_data('Slim', '', color);
        let options = await network.fetch_ind('Slim');

        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options,
            result,
        }
    }

    let
        width = parameter('width', '1000'),
        height = parameter('height', '2000'),
        ind2 = parameter('color', 'Белый'), // цвет
        ind3 = 'Створка влево', // открывание
        ind1 = 'Щеточный', // уплотнитель
        porog = 'Рамный', // уплотнитель
        webtype = parameter('webtype', 'Обычная'), // тип сетки плиссе
        type = 'Сетка',
        comment = parameter('comment', ''),
        count = parameter('count', 1),
        vidShtor = 'Полупрозрачная',
        cvetShtor = 'Антрацит'
    ;

    let fetchData = fetch($ind2);

    let
        montage_item,
        montage_price = 1;

    const changeInd2 = () => {
        fetchData = fetch($ind2)
    };

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count,

            w = +$width,
            h = +$height,
            packing_items = []
        ;

        let webName;
        switch (type) {
            case 'Сетка':
                webName = $webtype;
                break;
            case 'Ткань':
                webName = vidShtor + ' ' + cvetShtor;
                break;
            case 'Сетка/Ткань':
                webName = $webtype + ' и ' + vidShtor + ' ' + cvetShtor;
                break;
            default:
                webName = '';
        }

        let result = {
            type: 'slim',
            name: 'Slim',
            subname: [
                $width + 'x' + $height, ' ',
                $ind2, ' ', ind3, ' ', type, ' ', webName, ' ', ind1, ' ', ` ${porog} порог`
            ].join(''),
            title: [
                'Slim', ' ', $width + 'x' + $height, ' ',
                $ind2, ' ', ind3, ' ', type, ' ', webName, ' ', ind1, ' ', ` ${porog} порог`
            ].join(''),
            params: {
                ind1: ind1 + ` ${porog} порог`,
                ind2: $ind2,
                ind3: encode(JSON.stringify({
                    width: $width,
                    height: $height,
                    ind1,
                    ind2: $ind2,
                    ind3,
                    porog,
                    type,
                    webtype: $webtype,
                    vidShtor,
                    cvetShtor
                })),
                ind4: $width,
                ind5: $height,
            },


            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture: 22
        };

        const nt = data.result.find((el) => el.name.includes('аценка на ткань'))
        let nacenkaTkanRozn = 1
        let nacenkaTkanOpt = 1
        let nacenkaTkanSebest = 1
        if (nt) {
            nacenkaTkanRozn = 1 + (nt.price / 100)
            nacenkaTkanOpt = 1 + (nt.opt_price / 100)
            nacenkaTkanSebest = 1 + (nt.sebestomost / 100)
        }

        _.forEach(data.result, function (item) {
            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;

            if (name.includes('профиль рамы slim')) {
                switch (ind3) {
                    case 'Створка влево':
                    case 'Створка вправо':
                    case 'Створка от краев к середине':
                    case 'Створка от середины к краям':
                        if (porog == 'Рамный') {
                            kolvo = (((w - 30) * 2 + (h - 50) * 2) / 1000).toFixed(3);
                        } else {
                            kolvo = (((w - 30) + (h - 50 + 10) * 2) / 1000).toFixed(3);
                        }
                        break;


                    case 'Створка вертикал':
                    case 'Створка сверху вниз':
                    case 'Створка снизу вверх':
                        if (porog == 'Рамный') {
                            kolvo = (((w - 50) * 2 + (h - 30) * 2) / 1000).toFixed(3);
                        } else {
                            kolvo = (((w - 50) + (h - 30 + 10) * 2) / 1000).toFixed(3);
                        }
                        break;
                }
            }

            if (name.includes('порог') && porog.toLowerCase().includes('низкий')) {
                kolvo = ((w - 30) / 1000).toFixed(3);
            }

            if (name.includes('профиль створки slim')
                || (name.includes('еточный') && ind1.toLowerCase().includes('еточный'))) {
                switch (ind3) {
                    case 'Створка влево':
                    case 'Створка вправо':
                        if (porog == 'Рамный') {
                            kolvo = ((h - 58) / 1000).toFixed(3);
                        } else {
                            kolvo = ((h - 58 + 14) / 1000).toFixed(3);
                        }
                        break;

                    case 'Створка сверху вниз':
                    case 'Створка снизу вверх':
                        kolvo = ((w - 58) / 1000).toFixed(3);
                        break;

                    case 'Створка от краев к середине':
                    case 'Створка от середины к краям':
                        if (porog == 'Рамный') {
                            kolvo = ((h - 58) * 2 / 1000).toFixed(3);
                        } else {
                            kolvo = ((h - 58 + 14) * 2 / 1000).toFixed(3);
                        }
                        break;
                }
            }


            if (name.includes('магнит slim') && ind1.toLowerCase().includes('магнит')) {
                switch (ind3) {
                    case 'Створка от краев к середине':
                        if (porog == 'Рамный') {
                            kolvo = ((h - 58) * 2 / 1000).toFixed(3);
                        } else {
                            kolvo = ((h - 58 + 14) * 2 / 1000).toFixed(3);
                        }
                        break;
                }
            }

            if (name.includes('магнит в рам') && ind1.toLowerCase().includes('магнит')) {
                switch (ind3) {
                    case 'Створка влево':
                    case 'Створка вправо':
                        if (porog == 'Рамный') {
                            kolvo = ((h - 58) / 1000 * 2).toFixed(3);
                        } else {
                            kolvo = ((h - 58 + 14) / 1000 * 2).toFixed(3);
                        }
                        break;

                    case 'Створка сверху вниз':
                    case 'Створка снизу вверх':
                        kolvo = ((w - 58) / 1000 * 2).toFixed(3);
                        break;

                    case 'Створка от середины к краям':
                        if (porog == 'Рамный') {
                            kolvo = ((h - 58) / 1000 * 4).toFixed(3);
                        } else {
                            kolvo = ((h - 58 + 14) / 1000 * 4).toFixed(3);
                        }
                        break;
                }
            }

            // системе СЛИМ при расчете  объема сетки (полотна) в кол-ве волн нужно увеличить на 10% (с округлением в большую сторону)

            if (name.includes('сетка мс плиссе') && type != 'Ткань') {

                if (!$webtype) return;

                switch (true) {
                    case $webtype === 'Обычная' && (name.includes('антипыль') || name.includes('антимошка') || name.includes('антикошка')):
                        return;

                    case $webtype === 'Антипыль' && !name.includes('антипыль'):
                        return;

                    case $webtype === 'Антимошка' && !name.includes('антимошка'):
                        return;

                    case $webtype === 'Антикошка' && !name.includes('антикошка'):
                        return;
                }

                let k = 1;
                if (name.includes('антипыль') || name.includes('антикошка')) {
                    k = 1.1;
                }

                let wave;

                switch (ind3) {
                    case 'Створка влево':
                    case 'Створка вправо':

                        wave = Math.ceil(w * 55 / 1100);
                        if (porog == 'Рамный') {
                            kolvo = (((h - 35) / 1000 * wave * 0.034) * 1.1 * k).toFixed(4);
                        } else {
                            kolvo = (((h - 35 + 17) / 1000 * wave * 0.034) * 1.1 * k).toFixed(4);
                        }
                        break;
                    case 'Створка от краев к середине':
                    case 'Створка от середины к краям':
                        wave = Math.ceil(w * 55 / 1100);
                        if (porog == 'Рамный') {
                            kolvo = (((h - 35) / 1000 * wave * 0.034) * 1.1 * k).toFixed(4);
                        } else {
                            kolvo = (((h - 35 + 17) / 1000 * wave * 0.034) * 1.1 * k).toFixed(4);
                        }
                        break;

                    default:  //Створка вертикал
                        wave = Math.ceil(h * 55 / 1100);
                        kolvo = (((w - 35) / 1000 * wave * 0.034) * 1.1 * k).toFixed(3);
                        break;
                }
            }
            if (type != 'Сетка') {
                if (vidShtor === 'Полупрозрачная' && name.includes('плиссированная шторка из полиэстера')) {
                    if (item.ind2 === cvetShtor) {
                        kolvo = ((w - 2) * h / 2.2 * 0.028 / 10000).toFixed(3);
                    }
                } else {
                    const shtorKeywords = shtorkaKeywordForCalc(vidShtor, cvetShtor, data.result);

                    if (shtorKeywords.some(kw => name.includes(kw)) && name.includes(cvetShtor.toLowerCase())) {
                        kolvo = ((w / 1000) * h / 7.7 * 10 / 1000).toFixed(3);
                    }
                }
            }


            if (name.includes('лента со скотчем')) {
                let wave;

                switch (ind3) {
                    case 'Створка влево':
                    case 'Створка вправо':
                        kolvo = ((h - 35) / 1000 * 2).toFixed(3);
                        break;
                    case 'Створка от краев к середине':
                    case 'Створка от середины к краям':
                        kolvo = ((h - 35) / 1000 * 2 * 2).toFixed(3);
                        break;

                    default:  //'Створка вертикал
                        kolvo = ((w - 35) / 1000 * 2).toFixed(3);
                        break;
                }
            }

            let c, k;
            switch (ind3) {
                case 'Створка влево':
                case 'Створка вправо':
                case 'Створка от краев к середине':
                case 'Створка от середины к краям':
                    k = h;
                    break;

                default:  //'Створка вертикал
                    k = w;
                    break;
            }

            if (name.includes('нить мс плиссе')) {


                switch (ind3) {
                    case 'Створка влево':
                    case 'Створка вправо':

                        k = h;
                        switch (true) {
                            case (k - 50 - 100) < 1200: {
                                c = 2;
                                break;
                            }
                            case (k - 50 - 100) <= 1600: {
                                c = 3;
                                break;
                            }
                            case (k - 50 - 100) <= 2300: {
                                c = 4;
                                break;
                            }
                            default: {
                                c = 5;
                                break;
                            }
                        }
                        kolvo = (((w + h) * 2 + 300) / 1000 * c).toFixed(3);

                        break;

                    case 'Створка от краев к середине':
                    case 'Створка от середины к краям':
                        k = h;
                        switch (true) {
                            case (k - 50 - 100) < 1200: {
                                c = 2;
                                break;
                            }
                            case (k - 50 - 100) <= 1600: {
                                c = 3;
                                break;
                            }
                            case (k - 50 - 100) <= 2300: {
                                c = 4;
                                break;
                            }
                            default: {
                                c = 5;
                                break;
                            }
                        }
                        kolvo = 2 * (((w + h) * 2 + 300) / 1000 * c).toFixed(3);

                        break;


                    default:  //'Створка вертикал
                        k = w;

                        switch (true) {
                            case (k - 30 - 100) < 1200: {
                                c = 2;
                                break;
                            }
                            case (k - 30 - 100) <= 1600: {
                                c = 3;
                                break;
                            }
                            case (k - 30 - 100) <= 2300: {
                                c = 4;
                                break;
                            }
                            default: {
                                c = 5;
                                break;
                            }
                        }
                        kolvo = (((w + h) * 2 + 300) / 1000 * c).toFixed(3);
                        break;
                }


            }
            if (name.includes('пятка')) {
                kolvo = (2).toFixed(3);

                switch (ind3) {
                    case 'Створка от краев к середине':
                    case 'Створка от середины к краям':
                        kolvo = (kolvo * 2).toFixed(3);
                        break;
                }
            }

            if (APP_TYPE === 'moskitoscompany' || APP_TYPE === 'axis-one') {

                if (name.includes('угол')) {

                    if (porog == "Рамный" && name.includes('рамный')) {

                        kolvo = (4).toFixed(3);
                    }
                    if (porog != "Рамный" && name.includes('рамный')) {

                        kolvo = (2).toFixed(3);
                    }
                    if (porog != "Рамный" && name.includes('низкий')) {

                        kolvo = (2).toFixed(3);
                    }
                }

            } else {
                if (name.includes('угол')) {
                    kolvo = (4).toFixed(3);
                }

            }


            if (name.includes('работа')) {
                const isReverse = name.includes('реверс');

                switch (ind3) {
                    case 'Створка от середины к краям':
                        kolvo = isReverse ? 1 : 0;
                        break;

                    default:
                        kolvo = isReverse ? 0 : 1;
                        break;
                }
            }

            if (name.includes('заглушка ')) {
                kolvo = (4).toFixed(3);

            }

            if (name.includes('гвозд')) {
                kolvo = 2;
                switch (ind3) {
                    case 'Створка от краев к середине':
                    case 'Створка от середины к краям':
                        kolvo = (kolvo * 2).toFixed(3);
                        break;
                }
            }

            if (name.includes('пвх заглушка')) {
                kolvo = 4;
            }

            if (name.includes('заклеп')) {

                let c, k;
                switch (ind3) {
                    case 'Створка влево':
                    case 'Створка вправо':

                        k = h;

                        switch (true) {
                            case (k - 58 - 100) < 1200: {
                                c = 2;
                                break;
                            }
                            case (k - 58 - 100) <= 1600: {
                                c = 3;
                                break;
                            }
                            case (k - 58 - 100) <= 2300: {
                                c = 4;
                                break;
                            }
                            default: {
                                c = 5;
                                break;
                            }
                        }
                        break;

                    case 'Створка от краев к середине':
                    case 'Створка от середины к краям':
                        k = h;

                        switch (true) {
                            case (k - 58 - 100) < 1200: {
                                c = 2 * 2;
                                break;
                            }
                            case (k - 58 - 100) <= 1600: {
                                c = 2 * 3;
                                break;
                            }
                            case (k - 58 - 100) <= 2300: {
                                c = 2 * 4;
                                break;
                            }
                            default: {
                                c = 2 * 5;
                                break;
                            }
                        }
                        break;
                    default:  //'Створка вертикал
                        k = w;

                        switch (true) {
                            case (k - 30 - 100) < 1200: {
                                c = 2;
                                break;
                            }
                            case (k - 30 - 100) <= 1600: {
                                c = 3;
                                break;
                            }
                            case (k - 30 - 100) <= 2300: {
                                c = 4;
                                break;
                            }
                            default: {
                                c = 5;
                                break;
                            }
                        }
                        break;
                }


                kolvo = c * 4;
            }


            if (kolvo) {
                const isTkanMat = SHTORKA_TYPES.some(({keyword}) => keyword.some(kw => name.includes(kw)));

                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price * (isTkanMat ? nacenkaTkanRozn : 1));
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price * (isTkanMat ? nacenkaTkanOpt : 1));
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost * (isTkanMat ? nacenkaTkanSebest : 1));

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }

            if (name.includes('монтаж')) {
                montage_item = item;
            }

            if (name.includes('упаковка')) {
                packing_items.push(item);
            }

        }, 250);

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);


        let mprice = Math.round((result.price.rozn / quantity) / 100 * montage_item.procentSpisania / 100) * 100;
        montage_price = +(montage_item.opt_price > mprice ? montage_item.opt_price * quantity : mprice * quantity).toFixed(2);

        dispatch('mounting', {item: montage_item, price: montage_price});
        dispatch('packing', {items: packing_items, multiplier: w * h / 1000000});
        dispatch('item', result);
    });

    change();


    $: recomendWidth =
        ind3 === 'Створка от краев к середине' || ind3 ==='Створка от середины к краям'
            ? 1800
            : (options.recomend && options.recomend.width ? options.recomend.width : 1000);

</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    <!--<pre>{JSON.stringify(data, null, 4)}</pre>-->
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row d-flex">
            <div class="col-12 col-sm-7 ">
                <div class="row">
                    <span class="badge-danger text-white small rounded-2 text-center  text-uppercase"> { ($width > (options.recomend && options.recomend.width ? options.recomend.width : 6000) || $height > (options.recomend && options.recomend.height ? options.recomend.height : 6000)) ? 'Изделие с данным размером не подлежит гарантии' : '' }</span>
                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Цвет</label>
                                <select class="form-control form-select" bind:value={$ind2}
                                        on:change={() => {changeInd2(); change()}}>
                                    {#each Object.entries(color) as [value]}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Направление</label>
                                <select class="form-control form-select" bind:value={ind3}>
                                    {#each otkrivanie as item}
                                        <option value="{item}">{item}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">300 ≥ Ширина, мм ≥ { recomendWidth }</label>
                                <input type="number"
                                       class="form-control text-center { $width > recomendWidth ? 'text-danger' : '' }"
                                       step="10" min="300"
                                       max="{ options.max && options.max.width ? options.max.width : 2000 }"
                                       bind:value={$width} use:validate_int={$width}>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">300 ≥ Высота, мм
                                    ≥ { options.recomend && options.recomend.height ? options.recomend.height : 2200 }</label>
                                <input type="number"
                                       class="form-control text-center { $height > (options.recomend && options.recomend.height ? options.recomend.height : 2200) ? 'text-danger' : '' }"
                                       step="10" min="300"
                                       max="{ options.max && options.max.height ? options.max.height : 2200 }"
                                       bind:value={$height} use:validate_int={$height}>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Тип полотна</label>
                                <select class="form-control form-select" bind:value={type} on:change={change}>
                                    {#each types as value}
                                        {#if value !== 'Сетка/Ткань' || ind3 === 'Створка от краев к середине'}
                                            <option value="{value}">{value}</option>
                                        {/if}
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Уплотнитель</label>
                                <select class="form-control form-select" bind:value={ind1}>
                                    <option value="Без уплотнения">Без уплотнения</option>
                                    <option value="Щеточный">Щеточный</option>
                                    <option value="Магнитный">Магнитный</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    {#if type !== 'Ткань'}
                        <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Тип сетки</label>
                                    <select class="form-control form-select" bind:value={$webtype} on:change={change}>
                                        <option value="" disabled selected>— Выберите тип —</option>
                                        {#each webtypes as value}
                                            <option value="{value}">{value}</option>
                                        {/each}
                                    </select>
                                </div>
                            </div>
                        </div>
                    {/if}
                    {#if type !== 'Сетка'}
                        <div class="shtorType">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Вид шторы</label>
                                    <select class="form-control form-select" bind:value={vidShtor}
                                            on:change={() => cvetShtor = shtorkaColors(vidShtor, data.result)[0]}>
                                        {#each availableShtorTypes(data.result) as {type}}
                                            <option value="{type}">{type}</option>
                                        {/each}
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="shtorColor">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Цвет шторы</label>
                                    <select class="form-control form-select" bind:value={cvetShtor}>
                                        {#each shtorkaColors(vidShtor, data.result) as value}
                                            <option value="{value}">{value}</option>
                                        {/each}
                                    </select>
                                </div>
                            </div>
                        </div>
                    {/if}
                </div>

            </div>

            <div class="col-12 col-sm-5 text-center d-flex order-last  order-sm-first justify-content-around">
                <img style="max-height: 250px" class="img-fluid  p-3"
                     src="/img/plisse/ind3/{ind3.toLowerCase().replaceAll(' ', '-')}-{$ind2.toLowerCase()}.jpg"/>
            </div>
        </div>

        <div class="row">

            {#if APP_TYPE === 'moskitoscompany' || APP_TYPE === 'axis-one'}
                <div class="col-6">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Порог</label>
                            <select class="form-control form-select" bind:value={porog}>
                                <option value="Рамный">Рамный</option>
                                <option value="Низкий">Низкий</option>
                            </select>
                        </div>
                    </div>
                </div>
            {/if}

            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Количество</label>
                        <input type="number" class="form-control" min="1" bind:value={$count}>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <RalColor color={$ind2} bind:comment={$comment}/>
            <DekoRalColor color={$ind2} bind:comment={$comment}/>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <div class="input-wrapper">
                            <label class="form-label">Примечание</label>
                            <textarea class="form-control" bind:value={$comment}></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/await}

<div id="toast-ind1" class="toast-box toast-top bg-danger">
    <div class="in">
        <div class="text">
            При высоте больше 1400 мм рекомендуется поставить перемычку
        </div>
    </div>
</div>
